import { getFreespinChoicePopupAction } from 'automaton/actions/FreespinChoicePopupAction'
import { getFreespinsStartAction } from 'automaton/actions/FreespinStartAction'
import { getFreespinStartDelayState } from 'automaton/states/FreespinsStartDelayState'

export function getFreespinStartState() {
  const name = 'FS-START'
  game.models.ModeModel.buyFeature = false
  const actions = [getFreespinsStartAction(), getFreespinChoicePopupAction()]
  const transition =  getFreespinStartDelayState

  return {
    name,
    actions,
    transition,
  }
}
